<template>
  <div class="app-container">
    <img
      src="https://school-gongyu.oss-cn-beijing.aliyuncs.com/school-gongyu/zuhe.png"
      alt=""
      class="topImg"
    />
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
      v-if="isOne"
    >
      <div
        class="radio-group"
        v-if="
          form.dateTime == '第一时间段' ||
          (form.xGrade == '高一' && form.dateTime == '第二时间段')
        "
      >
        <div
          v-for="option in options"
          :key="option.value"
          class="radio-option"
          :class="{ selected: selectedOption === option.value }"
          @click="selectOption(option.value)"
        >
          <div class="radio-input"></div>
          <span class="radio-label">{{ option.label }}</span>
        </div>
      </div>
      <div class="time" v-if="form.dateTime == '第一时间段'">15:30-16:10</div>
      <div class="time" v-if="form.dateTime == '第二时间段'">16:20-17:00</div>

      <el-form-item label="姓名" prop="xStuName">
        <el-input v-model="form.xStuName" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="学号" prop="xStuCode">
        <el-input
          v-model="form.xStuCode"
          placeholder="请输入学号"
          @change="getXuehao"
        />
      </el-form-item>

      <el-form-item label="班级" prop="xClasses">
        <el-input v-model="form.xClasses" placeholder="请输入班级" />
      </el-form-item>

      <div class="radio-group-ke">
        <div
          v-for="option in keList"
          :key="option.couName"
          class="radio-option-ke"
          :class="{
            selected: selectedKe === option.couName,
          }"
          @click="selectKe(option.couName)"
        >
          <div class="radio-input-ke">
            <span class="checkmark2"></span>
          </div>
          <div class="label-container-ke">
            <span class="radio-label-ke">{{ option.couName }}</span>
          </div>
        </div>
      </div>
      <div class="submitBtn" @click="toSubmit">提交</div>
    </el-form>
    <div class="tips" v-if="success">您已选课成功！</div>
    <div class="failBox" v-if="failShow">
      <div class="title">提交失败!</div>
      <div class="smalTitle">人数已达上限，请重新选课</div>
      <div class="xuanBtn" @click="toXuan">确定</div>
    </div>

    <div class="failBox" v-if="ecTiShow">
      <div class="title">提交成功!</div>
      <div class="smalTitle">请继续选课</div>
      <div class="xuanBtn" @click="toEr">确定</div>
    </div>

    <div class="failBox" v-if="chongShow">
      <div class="title">课程重复!</div>
      <div class="smalTitle">请继续选课</div>
      <div class="xuanBtn" @click="toChong">确定</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Activity",
  data() {
    return {
      isOne: true,
      success: false,
      failShow: false,
      ecTiShow: false,
      chongShow: false,
      // 表单参数
      form: {
        xStuName: "",
        xStuCode: "",
        couName: "",
        dateTime: "第一时间段",
        xGrade: "",
        xClasses: "",
      },
      // 表单校验
      rules: {
        xStuName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        xStuCode: [
          {
            required: true,
            message: "请输入学号",
            trigger: "blur",
          },
        ],
        xClasses: [
          {
            required: true,
            message: "请输入班级",
            trigger: "blur",
          },
        ],
      },
      selectedOption: "",
      options: [
        { value: "五年级", label: "五年级" },
        { value: "六年级", label: "六年级" },
        { value: "初一", label: "初一" },
        { value: "初二", label: "初二" }, 
        { value: "高一", label: "高一" },
      ],
      selectedKe: null,
      keList: [],
    };
  },
  created() {},
  methods: {
    getXuehao(e) { 
      this.api.keDetail({ xStuCode: e }).then((res) => {
        if (res.data.data.length > 0) {
          this.form = res.data.data[0];
          this.form.dateTime = "第二时间段";

          this.api
            .keApi({ couCode: this.form.xGrade, dateTime: "第二时间段" })
            .then((res) => {
              if (
                this.form.xGrade == "高一" &&
                this.form.dateTime == "第二时间段"
              ) {
                this.keList = res.data;
              } else {
                let arr = res.data;
                let temp = res.data.pop();
                this.keList = arr;
              }
            });
        }
      });
    },
    selectOption(value) {
      this.selectedOption = value;
      this.form.xGrade = value;
      if (this.form.xGrade == "高一") {
        this.form.dateTime = "第二时间段";
      } else {
        this.form.dateTime = "第一时间段";
      }
      this.api
        .keApi({ couCode: this.selectedOption, dateTime: this.form.dateTime })
        .then((res) => {
          if (
            (this.form.xGrade == "高一" &&
              this.form.dateTime == "第二时间段") ||
            (this.form.xGrade !== "高一" && this.form.dateTime == "第一时间段")
          ) {
            this.keList = res.data;
          } else {
            let arr = res.data;
            let temp = res.data.pop();
            this.keList = arr;
            console.log(this.keList);
          }
        });
    },
    getSelectedLabel() {
      const selected = this.options.find(
        (option) => option.value === this.selectedOption
      );
      return selected ? selected.label : "";
    },

    selectKe(couName) {
      this.selectedKe = couName;
      this.form.couName = couName;
    },
    getSelectedKe() {
      const selected = this.options.find(
        (option) => option.couName === this.selectedKe
      );
      return selected ? selected.couName : "";
    },
    toXuan() {
      this.isOne = true;
      this.failShow = false;
    },
    toEr() {
      this.isOne = true;
      this.ecTiShow = false;
    },
    toChong() {
      this.isOne = true;
      this.chongShow = false;
    },
    toSubmit() {
      if (
        this.form.xGrade == "" ||
        this.form.xStuCode == "" ||
        this.form.xStuName == "" ||
        this.form.xClasses == ""
      ) {
        this.$message.error("请完善您的信息");
      } else {
        this.api.tiKe(this.form).then((res) => {
          //   1选课成功
          if (res.data.msg == "1") {
            if (this.form.xGrade == "高一") {
              this.isOne = false;
              this.success = true;
            } else {
              this.api
                .keDetail({ xStuCode: this.form.xStuCode })
                .then((res) => {
                  if (res.data.data.length == 1) {
                    this.form = res.data.data[0];
                    if (
                      this.form.couName == "游泳" ||
                      this.form.couName == "舞蹈表演"
                    ) {
                      this.success = true;
                      this.isOne = false;
                    } else {
                      this.ecTiShow = true;
                      this.isOne = false;
                      this.form.dateTime = "第二时间段";
                      this.api
                        .keApi({
                          couCode: this.form.xGrade,
                          dateTime: this.form.dateTime,
                        })
                        .then((res) => {
                          this.keList = res.data;
                        });
                    }
                  } else if (res.data.data.length > 1) {
                    this.success = true;
                    this.isOne = false;
                  }
                });
            }
          } else if (res.data.msg == "2") {
            this.failShow = true;
            this.isOne = false;
          } else if (res.data.msg == "0") {
            this.chongShow = true;
            this.isOne = false;
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.app-container {
  width: 100%;
  min-height: 100vh;
  background: rgb(153, 34, 35);
}
.topImg {
  width: 375px;
  height: 180px;
}

.el-form {
  width: 350px;
  padding-top: 20px;
  padding-bottom: 100px;
  margin: 0 auto;
}

div /deep/.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: white;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

div /deep/.el-button--primary {
  color: rgb(153, 34, 35);
  background-color: white;
  border-color: white;
  font-weight: bold;
}

/* 年级css */
.radio-group {
  width: 350px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.radio-option {
  width: 98px;
  height: 30px;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
}

.radio-option.selected {
  border-color: rgb(153, 34, 35);
  background: #e3f2fd;
  color: rgb(153, 34, 35);
}
.radio-input {
  margin-right: 15px;
  width: 20px;
  height: 20px;
  border: 2px solid #bdc3c7;
  border-radius: 50%;
  display: none;
}

.time {
  font-size: 20px;
  color: white;
  margin: 30px 0;
}

/* 课程选择 */
.radio-group-ke {
  width: 350px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 25px;
  color: white;
}
.radio-option-ke {
  display: flex;
  align-items: center;
  padding: 5px 20px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.radio-option-ke.selectedKe {
  border-color: rgb(153, 34, 35);
  background: #e3f2fd;
}
.radio-input-ke {
  margin-right: 15px;
  width: 20px;
  height: 20px;
  border: 2px solid #bdc3c7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  border: 2px solid white;
  position: relative;
}

.radio-option-ke.selected .radio-input-ke {
  background: #ffffff;
}
.checkmark2 {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  position: absolute;
  top: 6px;
  left: 6px;
  background: rgb(153, 34, 35);
}

.radio-label-ke {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  flex-grow: 1;
}

/* 提交 */
.submitBtn {
  width: 100px;
  height: 30px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 16px;
  color: #992223;
  text-align: center;
  line-height: 30px;
  margin: 50px auto;
}

.tips {
  font-family: Abhaya Libre ExtraBold, Abhaya Libre ExtraBold;
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
  margin-top: 200px;
}

.failBox {
  width: 255px;
  height: 130px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
}

.title {
  font-family: 719-CAI978-719, 719-CAI978-719;
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  letter-spacing: 1px;
  text-align: center;
  margin: 10px auto;
}
.smalTitle {
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  text-align: center;
  text-align: center;
}

.xuanBtn {
  width: 100px;
  height: 30px;
  background: #992223;
  border-radius: 8px 8px 8px 8px;
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  margin: 10px auto;
}
</style>